import type { $Enums } from '@prisma/client'
import type { FileFormValue } from '@/pages/tad.ai/ai-music-generator/_types/form'


import { useState } from 'react';
interface HistoryModalData {
  musicModel: Extract<$Enums.MusicModel, 'V2' | 'V3'>
  musicType: $Enums.MusicType
  handleUse: (data: FileFormValue) => void
}
export function useHistoryModal() {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<HistoryModalData>({
    musicModel: 'V3',
    musicType: 'Song',
    handleUse: () => {},
  })

  const show = (data: HistoryModalData) => {
    setData(data)
    setOpen(true)
  }

  const close = () => {
    setOpen(false)
  }

  return {
    open,
    show,
    close,
    data,
  }
}
